import styled, { css } from 'styled-components';

import { BREAKPOINTS, colors } from '../../../../common/styles/style-constants';

export const Wrapper = styled.div`
  margin-bottom: 5px;

  @media (min-width: ${BREAKPOINTS.tabletMin}px) {
    margin: 5px;
  }
`;

const highlightedStyles = css`
  color: ${colors.sage7};
  border-color: ${colors.sage6};
  outline: none !important;
`;

export const StyledButton = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: ${props => (props.hasLogo ? 'row' : 'row-reverse')};
  cursor: pointer;
  padding: 16px 20px;
  text-align: left;
  width: 100%;
  color: ${props => (props.checked ? colors.sage7 : colors.darkCharcoal)};
  border-radius: 10px;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.1);
  background: ${props => (props.checked ? colors.lightSage : colors.white)};
  border: ${props =>
    (props.checked ? `1px solid ${colors.sage6}` : `1px solid ${colors.gray4}`)};
  transition: all 0.2s ease-in-out;

  &:focus {
    ${highlightedStyles}
  }

  /* Only show hover styles when pointer is fine (mouse/trackpad) */
  /* Touchscreen hover gets stuck */
  @media (pointer: fine) {
    &:hover {
      ${highlightedStyles}
    }
  }

  &:active {
    color: ${colors.sage7};
    background: ${colors.lightSage};
    border-color: ${colors.sage6};
  }

  @media (min-width: ${BREAKPOINTS.tabletMin}px) {
    flex-direction: column;
    justify-content: center;
    width: 180px;
    min-height: ${props => props.minHeightDesktop};
    height: 100%;
    text-align: center;
    padding: 25px 15px;
  }
`;
